/* ==========================================================
   VECTOR COMPONENT VC-008
   REVIEWS & SOCIAL PROOF
   FINAL VERSION 1.1
   ========================================================== */

class VectorReviews {
  constructor(root = document) {
    this.root = root;
    this.initialiseBadges();
  }

  initialiseBadges() {
    const badges = this.root.querySelectorAll('.jdgm-prev-badge');

    badges.forEach((badge) => {
      if (badge.dataset.vectorReviewsReady === 'true') {
        return;
      }

      badge.dataset.vectorReviewsReady = 'true';

      this.prepareBadge(badge);
      this.bindBadge(badge);
    });
  }

  prepareBadge(badge) {
  const averageRating = Number.parseFloat(
    badge.dataset.averageRating || '0'
  );

  const reviewCount = Number.parseInt(
    badge.dataset.numberOfReviews || '0',
    10
  );

  badge.setAttribute('role', 'button');
  badge.setAttribute('tabindex', '0');
  badge.setAttribute(
    'aria-label',
    `Rated ${averageRating.toFixed(1)} out of 5 from ${reviewCount} customer ${
      reviewCount === 1 ? 'review' : 'reviews'
    }. Read reviews.`
  );

  const existingText = badge.querySelector('.jdgm-prev-badge__text');

  if (existingText) {
    existingText.hidden = true;
  }

  let summary = badge.querySelector('.vector-review-summary');

  if (!summary) {
    summary = document.createElement('span');
    summary.className = 'vector-review-summary';

    const stars = badge.querySelector('.jdgm-prev-badge__stars');

    if (stars) {
      stars.insertAdjacentElement('afterend', summary);
    } else {
      badge.prepend(summary);
    }
  }

  summary.textContent =
    `${averageRating.toFixed(1)} ` +
    `(${reviewCount} ${reviewCount === 1 ? 'Review' : 'Reviews'})`;

  if (!badge.querySelector('.vector-review-read-link')) {
    const readReviews = document.createElement('span');

    readReviews.className = 'vector-review-read-link';
    readReviews.textContent = 'Read reviews →';
    readReviews.setAttribute('aria-hidden', 'true');

    badge.appendChild(readReviews);
  }
}
  bindBadge(badge) {
    badge.addEventListener('click', (event) => {
      event.preventDefault();
      this.goToReviews();
    });

    badge.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.goToReviews();
    });
  }

  findReviewWidget() {
    return (
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('.jdgm-widget.jdgm-review-widget') ||
      document.querySelector('.jdgm-review-widget')
    );
  }

  goToReviews() {
    const reviewWidget = this.findReviewWidget();

    if (!reviewWidget) {
      console.warn('VC-008: Judge.me Review Widget not found.');
      return;
    }

    reviewWidget.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    window.setTimeout(() => {
      reviewWidget.classList.remove('vector-reviews-highlight');

      /* Restart animation if clicked more than once */
      void reviewWidget.offsetWidth;

      reviewWidget.classList.add('vector-reviews-highlight');
    }, 500);

    window.setTimeout(() => {
      reviewWidget.classList.remove('vector-reviews-highlight');
    }, 1900);
  }
}

function initialiseVectorReviews(root = document) {
  new VectorReviews(root);
}

document.addEventListener('DOMContentLoaded', () => {
  initialiseVectorReviews();
});

/* Judge.me can finish loading after the page itself */

window.addEventListener('load', () => {
  window.setTimeout(() => {
    initialiseVectorReviews();
  }, 800);
});

/* Shopify Theme Editor support */

document.addEventListener('shopify:section:load', (event) => {
  window.setTimeout(() => {
    initialiseVectorReviews(event.target);
  }, 300);
});

/* ==========================================================
   END VC-008
   ========================================================== */